import React, { useEffect, useState } from 'react';
import { userAPI, showApiError } from '../../services/api';
import './MyProfilePage.css';

const ROLE_LABEL = {
  ADMIN: '관리자',
  USER: '사용자',
};

const formatPhoneNumber = (value) => {
  if (!value) return '-';
  const digits = String(value).replace(/\D/g, '');
  if (digits.length === 11) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return value;
};

const MyProfilePage = ({ user }) => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.id) {
      setLoading(false);
      return;
    }

    let cancelled = false;

    const loadProfile = async () => {
      try {
        setLoading(true);
        const data = await userAPI.get(user.id);
        if (!cancelled) {
          setProfile(data);
        }
      } catch (error) {
        if (!cancelled) {
          showApiError(error, '내 정보를 불러오지 못했습니다.');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadProfile();

    return () => {
      cancelled = true;
    };
  }, [user?.id]);

  const displayUser = profile || user;

  return (
    <div className="my-profile-page">
      <div className="my-profile-header">
        <h2>내 정보</h2>
        <p>계정 정보를 확인할 수 있습니다.</p>
      </div>

      {loading ? (
        <div className="my-profile-state">내 정보를 불러오는 중…</div>
      ) : (
        <div className="my-profile-card">
          <div className="my-profile-row">
            <span className="my-profile-label">아이디</span>
            <span className="my-profile-value">{displayUser?.username || '-'}</span>
          </div>
          <div className="my-profile-row">
            <span className="my-profile-label">이름</span>
            <span className="my-profile-value">{displayUser?.name || '-'}</span>
          </div>
          <div className="my-profile-row">
            <span className="my-profile-label">전화번호</span>
            <span className="my-profile-value">{formatPhoneNumber(displayUser?.phoneNumber)}</span>
          </div>
          <div className="my-profile-row">
            <span className="my-profile-label">권한</span>
            <span className="my-profile-value">
              {ROLE_LABEL[displayUser?.role] || displayUser?.role || '-'}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyProfilePage;
